import React, { useState, useEffect, useCallback } from 'react';
import Body from '../static/Body';
import Card from '../static/Card';
import { motion } from 'framer-motion';
import Text from '../elements/TextComponent';
import { ApiResponse, BotItem } from '../../api/types';
import { deleteAssistant, getAssistantList } from '../../api/assistantsApi';
import BotList from '../static/BotList';
import BotListLoading from '../static/BotListLoading';
import BotListError from '../static/BotListError';

const useFetchAssistantList = () => {

  const [bots, setBots] = useState<BotItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBots = useCallback(async () => {
    setLoading(true);
    const res: ApiResponse<BotItem[]> = await getAssistantList();
    if (res.error) {
      setError(res.error);
    } else {
      setBots(Array.isArray(res.data) ? res.data : []);
      setError(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchBots();
  }, [fetchBots]);

  return { bots, loading, error, refresh: fetchBots };
};

interface Props {
  onSelectAnalytics: (botId: string) => void;
}

const Assistants: React.FC<Props> = ({ onSelectAnalytics }) => {
    const handleViewAnalytics = (botId: string) => {
      onSelectAnalytics(botId); // Bubble up to Dashboard
    };
    const { bots, loading, error, refresh } = useFetchAssistantList();

    const handleDelete = async (botId: string) => {
    try {
        await deleteAssistant({ botId }); // your delete function
        await refresh();        // re-fetch the list
    } catch (err) {
    }
    };

    return (
        <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.3 }}
              >
                <Body>
                    <Card width="92%">
                        <Text
                            text="Assistants List"
                            fontSize="26px"
                            fontWeight="700"
                            lineHeight="28px"
                            color="#030303"
                            textAlign="left"
                            />
                            <div className='margin-top-10'></div>
                        <Text
                            text="Manage your assistants here."
                            fontSize="16px"
                            fontWeight="400"
                            lineHeight="28px"
                            color="#030303"
                            textAlign="left"
                            />
                    </Card>
                    <Card height={'635px'} width="92%">
                        {loading ? <BotListLoading></BotListLoading> : 
                            <BotList
                            bots={bots}
                            onDelete={async (id) => await handleDelete(id)}
                            onViewAnalytics={(id) => handleViewAnalytics(id)}
                            />
                        }
                        {error ? <BotListError message={error}></BotListError> : null}
                    </Card>
                </Body>
        </motion.div>
    )
}

export default Assistants;